import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../styles/global.css";
import {
	Collapse,
	Navbar,
	NavbarToggler,
	NavbarBrand,
	Nav,
	NavItem,
	NavLink
} from 'reactstrap';

export default (props) => {
	const [isOpen, setIsOpen] = useState(false);
	const toggle = () => setIsOpen(!isOpen);
	
	return (
		<div>
			<Navbar color="dark" dark expand="md">
				<NavbarBrand href="/">COVID-19 Article Classification</NavbarBrand>
				<NavbarToggler onClick={toggle} />
				<Collapse isOpen={isOpen} navbar>
					<Nav className="mr-auto" navbar>
						<NavItem>
							<NavLink href="/about/">About</NavLink>
						</NavItem>
						<NavItem>
							<NavLink href="/contact/">Contacts</NavLink>
						</NavItem>
					</Nav>
				</Collapse>
			</Navbar>
			{props.children}
		</div>
	)
}